import * as countryCodes from "country-codes-list";
import { CollectionType } from "src/enums/collectionType";
import { Incoterms } from "src/enums/incoterms";

export const MAX_VENDORS_PER_ACCOUNT = 3;

export const VENDOR_LOCATIONS = ["United Kingdom", "United States", "Germany"];

export const INCO_TERMS_OPTIONS = [
  { value: Incoterms.EXW, label: "EXW - EX WORKS" },
  { value: Incoterms.FCA, label: "FCA - FREE CARRIER" },
  { value: Incoterms.FAS, label: "FAS - FREE ALONGSIDE SHIP" },
  { value: Incoterms.FOB, label: "FOB - FREE ON BOARD" },
  { value: Incoterms.CFR, label: "CFR - COST & FREIGHT" },
  { value: Incoterms.CIF, label: "CIF - COST, INSURANCE & FREIGHT" },
  { value: Incoterms.CPT, label: "CPT - COST PAID TO" },
  { value: Incoterms.CIP, label: "CIP - CARRIER & INSURANCE PAID TO" },
  { value: Incoterms.DPU, label: "DPU - DELIVERED AT PLACE UNLOADED" },
  { value: Incoterms.DAP, label: "DAP - DELIVERED AT PLACE" },
  { value: Incoterms.DDP, label: "DDP - DELIVERED AT DUTY PAID" },
  { value: Incoterms.UK_SOURCED_BRAND, label: "UK Sourced Brand" },
  { value: Incoterms.DE_SOURCED_BRAND, label: "DE Sourced Brand" }
];

// Country options for Country of Export field
// Format: { value: "US", label: "US - United States" }
export const COUNTRY_OF_EXPORT_OPTIONS = (() => {
  const countryList = countryCodes.customList("countryCode", "{countryCode} - {countryNameEn}");
  return Object.entries(countryList)
    .map(([code, label]) => ({
      value: code,
      label: label as string
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
})();

// Collection type options for Collection Order Vendor field
// Derived from CollectionType enum to maintain single source of truth
export const COLLECTION_TYPE_OPTIONS = Object.values(CollectionType);
